import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import { useState } from 'react';

import { GeopostPopup } from 'components/geopostPopup/GeopostPopup';
import { SeismicWellContent } from './SeismicWellContent';
import { Position } from 'components/geopostPopup/models/enums/Position';
import { ILineString } from 'features/seismic/models/interfaces/ILineString';
import { SurveyType } from 'features/seismic/models/enums/SurveyType';
import { Reset } from 'components/icons/components';

export function SeismicWellPopup ({ opened, setOpened, dataGeometryLine, surveyType, runWebtour = false }:Props){
    const { t } = useTranslation();
    const [refreshWell, setRefreshWell] = useState<number>(0);

    const refresh = () => {
        setRefreshWell(refreshWell + 1);
    };

    const buildIconHeaders = () => [
        <IconButton color='inherit' size='small' onClick={refresh} title={t('refresh')}>
            <Reset />
        </IconButton >
    ];

    return (
        <GeopostPopup
            temporaryIgnoreFlexInContainer={false}
            open={opened}
            title={t('wells')}
            onChangeOpen={value => setOpened(value)}
            iconHeaders={buildIconHeaders()}
            overlay={false}
            height={536}
            width={395}
            position={surveyType === SurveyType.Seismic2D ? Position.bottomRight : Position.bottomLeft}
            resizable={false}
            rebuildOnOpen={false}
            padding={'15px'}
        >
            <SeismicWellContent opened={opened} setOpened={setOpened} dataGeometryLine={dataGeometryLine} surveyType={surveyType} runWebtour={runWebtour} refreshWell={refreshWell}/>
        </GeopostPopup>
    );
}

interface Props {
    opened: boolean;
    setOpened: (value: boolean) => void;
    dataGeometryLine: ILineString | null;
    surveyType: SurveyType,
    runWebtour?: boolean,
}